import React, { useState, useEffect } from "react";
import { getIcons } from "../../Constant/Constant";
// import axios from 'axios';
import { showErrorToast } from "../../Constant/Notification";
import marketingHubService from "../../Services/MarketingHubService";

const icons = getIcons();

const leadsData = [
  { id: "L0CTrn0qwWlHWvq2gXDm",
     label: "Fresh ",
      icon: icons.freshIcon
     },
  {
    id: "Auf9SQFhiKF7WRM9ZiTA",
    label: "Follow-up",
    icon: icons.interestedIcon,
  },
  { 
    id: "gJxbL16EjFbzDFCoQU5G",
     label: "Dealing",
      icon: icons.dealingIcon 
    },
  {
    id: "znvixWClH1PDoCXO4Aat",
    label: "Registered Client",
    icon: icons.customerIcon,
  },
  {
    id: "yUuWlPRZEosdOeLzyL0f",
    label: "Unanswered",
    icon: icons.unansweredIcon,
  },
  {
    id: "VH26wB3VgVXBzoBJiqml",
    label: "Not Interested",
    icon: icons.notInterestedIcon,
  },
  {
    id: "9XSuBds8XzEmvVNDr3yr",
    label: "Junk",
    icon: icons.Junk,
  },
];

export default function LeadSelection({ method }) {
  const [selectedLead, setSelectedLead] = useState(leadsData[0].id);
  const [selectedLeadStatusData, setSelectedLeadStatusData] = useState({});
  const [leadCounts, setLeadCounts] = useState({
    L0CTrn0qwWlHWvq2gXDm: 0,
    Auf9SQFhiKF7WRM9ZiTA: 0,
    gJxbL16EjFbzDFCoQU5G: 0,
    znvixWClH1PDoCXO4Aat: 0,
    yUuWlPRZEosdOeLzyL0f: 0,
    VH26wB3VgVXBzoBJiqml: 0,
  });
  const [leadDetail, setLeadDetail] = useState([]);

  useEffect(() => {
    const fetchLeadCounts = async () => {
      const updatedLeadCounts = { ...leadCounts };

      await Promise.all(
        leadsData.map(async (lead) => {
          try {
            const response =
              await marketingHubService.getLeadBasedOnStatusWithId(lead.id);
            updatedLeadCounts[lead.id] = response.data.leadCount || 0;
            setLeadDetail((leadDetail) => [
              ...leadDetail,
              { leadStatusId: lead.id, data: response.data.leadIds },
            ]);
            if (leadsData[0].id == lead.id) {
              method(response.data.leadIds);
              setSelectedLeadStatusData(response.data.leadIds);
            }
          } catch (error) {
            showErrorToast(error.response.data);
            console.error(`Error fetching data for lead ID ${lead.id}:`, error);
          }
        })
      );

      setLeadCounts(updatedLeadCounts);
    };

    fetchLeadCounts();
  }, []);

  useEffect(() => {
    console.log(selectedLeadStatusData);
  }, [selectedLeadStatusData]);

  const handleSelectedLead = async (leadId) => {
    setSelectedLead(leadId);

    leadDetail.forEach((lead) => {
      if (lead.leadStatusId == leadId) {
        setSelectedLeadStatusData(lead.data);
        method(lead.data);
      }
    });
  };

  return (
    <div className="p-4 max-w-lg bg-white rounded-lg shadow-md">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold">Choose Leads</h2>
      </div>
      <ul className="space-y-3">
        {leadsData.map((lead) => (
          <li
            key={lead.id}
            className={`flex items-center justify-between p-3 rounded-lg cursor-pointer
              ${
                selectedLead === lead.id
                  ? "bg-green-100 border border-green-500"
                  : "bg-white border border-gray-300"
              }
            `}
            onClick={() => handleSelectedLead(lead.id)}
          >
            <div className="flex items-center space-x-3">
              <img src={lead.icon} alt="" />
              <span className="font-medium">{lead.label}</span>
              <span className="text-gray-600 font-medium">
                ({leadCounts[lead.id]})
              </span>
            </div>
            <div className="flex items-center space-x-2 float-right">
              <form>
                <input
                  type="radio"
                  name="lead"
                  checked={selectedLead === lead.id}
                  onChange={() => handleSelectedLead(lead.id)}
                  className="form-radio text-green-500 h-4 w-4"
                />
              </form>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
